export enum DealType {
    DEAL = 'DEAL',
    MERCHANT = 'MERCHANT',
    POST_OFFICE = 'POST_OFFICE'
}